import _ from 'lodash';
import React, { useContext, useCallback } from 'react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import presentationMetadata from './QuestionsPage.metadata.json5';
import './QuestionsPage.messages';

function QuestionsPage(props) {
    const { isComponentValid, initialValidation, onValidate } = useValidation('QualificationPage');
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');

    const {
        wizardData: submissionVM,
        updateWizardData,
        currentStep,
        disableNext,
        overrideProps,
        callbackMap
    } = props;

    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const breakpoint = useContext(BreakpointTrackerContext);

    const onNext = useCallback(
        async () => {
            submissionVM.value = await LoadSaveService
                .updateDraftSubmission(submissionVM.value, authHeader);
            return submissionVM;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [submissionVM]
    );

    const overrides = _.merge({
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            showOptional: true
        }
    }, overrideProps);

    const resolveCallbackMap = {
        ...callbackMap,
        onValidate: onValidate
    };

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={disableNext || !isComponentValid}
            onNext={onNext}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={submissionVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                callbackMap={resolveCallbackMap}
                onValidationChange={onValidate}
            />
        </WizardPage>
    );
}

QuestionsPage.propTypes = wizardProps;
export default QuestionsPage;
